"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));
var _Snackbar = require("../Snackbar");
var _usePrevious = _interopRequireDefault(require("../hooks/usePrevious"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Message = function Message(props) {
  var message = props.message,
    title = props.title;
  var prevMessage = (0, _usePrevious["default"])(message);
  var prevTitle = (0, _usePrevious["default"])(title);
  var _useTheme = (0, _styles.useTheme)(),
    duration = _useTheme.transitions.duration;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grow["default"], {
    "in": !!message,
    duration: {
      enter: duration.enteringScreen,
      exit: duration.leavingScreen
    },
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_Snackbar.SnackbarContent, _extends({}, props, {
    message: message || prevMessage,
    title: title || prevTitle
  }))));
};
Message.propTypes = {
  className: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  action: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  type: _propTypes["default"].oneOf(['error', 'success', 'warning', 'informative'])
};
Message.defaultProps = {
  className: undefined,
  onClose: undefined,
  title: undefined,
  message: undefined,
  action: null,
  type: undefined
};
var _default = exports["default"] = Message;